import { makeStyles } from "@material-ui/core/styles"

let disabledGreen = "#B3E0BD"
let darkHoverGreen = "#1F7D36"
let lightHoverGreen = "#C6E7CD"

const styles = makeStyles(theme => ({
  outlinedGreen: {
    color: theme.palette.success.main,
    borderColor: theme.palette.success.main,
    borderRadius: "25px",
    "&:hover": {
      backgroundColor: lightHoverGreen,
    },
    "&.Mui-disabled": {
      color: disabledGreen,
      borderColor: disabledGreen,
      backgroundColor: "#fff",
      boxShadow: "none",
      opacity: "unset",
    },
  },
  containedGreen: {
    color: "#fff",
    backgroundColor: theme.palette.success.main,
    borderRadius: "25px",
    "&:hover": {
      backgroundColor: darkHoverGreen,
    },
    "&.Mui-disabled": {
      borderColor: disabledGreen,
      backgroundColor: disabledGreen,
      color: "#fff",
      boxShadow: "none",
      opacity: "unset",
    },
  },
}))

export default styles
